import Shape01 from "./res/images/shapes/01.svg";
import Shape02 from "./res/images/shapes/02.svg";
import Shape03 from "./res/images/shapes/03.svg";
import Shape04 from "./res/images/shapes/04.svg";
import Shape05 from "./res/images/shapes/05.svg";
import Shape06 from "./res/images/shapes/06.svg";
import Shape07 from "./res/images/shapes/07.svg";
import Shape08 from "./res/images/shapes/08.svg";
import Shape09 from "./res/images/shapes/09.svg";
import Shape10 from "./res/images/shapes/10.svg";
import Shape11 from "./res/images/shapes/11.svg";
import Shape12 from "./res/images/shapes/12.svg";
import Shape13 from "./res/images/shapes/13.svg";
import Shape14 from "./res/images/shapes/14.svg";
import Shape15 from "./res/images/shapes/15.svg";
import Shape16 from "./res/images/shapes/16.svg";
import Shape17 from "./res/images/shapes/17.svg";
import Shape18 from "./res/images/shapes/18.svg";
import Shape19 from "./res/images/shapes/19.svg";
import Shape20 from "./res/images/shapes/20.svg";
import Shape21 from "./res/images/shapes/21.svg";
import Shape22 from "./res/images/shapes/22.svg";
import Shape23 from "./res/images/shapes/23.svg";
import Shape24 from "./res/images/shapes/24.svg";
import Shape25 from "./res/images/shapes/25.svg";
import Shape26 from "./res/images/shapes/26.svg";
import Shape27 from "./res/images/shapes/27.svg";
import Shape28 from "./res/images/shapes/28.svg";
import Shape29 from "./res/images/shapes/29.svg";
import Shape30 from "./res/images/shapes/30.svg";
import Shape31 from "./res/images/shapes/31.svg";
import Shape32 from "./res/images/shapes/32.svg";
import Shape33 from "./res/images/shapes/33.svg";
import Shape34 from "./res/images/shapes/34.svg";
import Shape35 from "./res/images/shapes/35.svg";
import Shape36 from "./res/images/shapes/36.svg";
import Shape37 from "./res/images/shapes/37.svg";
import Shape38 from "./res/images/shapes/38.svg";
import Shape39 from "./res/images/shapes/39.svg";
import Shape40 from "./res/images/shapes/40.svg";
import Shape41 from "./res/images/shapes/41.svg";
import Shape42 from "./res/images/shapes/42.svg";
import Shape43 from "./res/images/shapes/43.svg";
import Shape44 from "./res/images/shapes/44.svg";
import Shape45 from "./res/images/shapes/45.svg";
import Shape46 from "./res/images/shapes/46.svg";
import Shape47 from "./res/images/shapes/47.svg";
import Shape48 from "./res/images/shapes/48.svg";
import Shape49 from "./res/images/shapes/49.svg";
import Shape50 from "./res/images/shapes/50.svg";
import Shape51 from "./res/images/shapes/51.svg";
import Shape52 from "./res/images/shapes/52.svg";
import Shape53 from "./res/images/shapes/53.svg";
import Shape54 from "./res/images/shapes/54.svg";
import Shape55 from "./res/images/shapes/55.svg";
import Shape56 from "./res/images/shapes/56.svg";
import Shape57 from "./res/images/shapes/57.svg";
import Shape58 from "./res/images/shapes/58.svg";
import Shape59 from "./res/images/shapes/59.svg";
import Shape60 from "./res/images/shapes/60.svg";
import Shape61 from "./res/images/shapes/61.svg";
import Shape62 from "./res/images/shapes/62.svg";
import Shape63 from "./res/images/shapes/63.svg";
import Shape64 from "./res/images/shapes/64.svg";
import Shape65 from "./res/images/shapes/65.svg";
import Shape66 from "./res/images/shapes/66.svg";
import Shape67 from "./res/images/shapes/67.svg";
import Shape68 from "./res/images/shapes/68.svg";
import Shape69 from "./res/images/shapes/69.svg";
import Shape70 from "./res/images/shapes/70.svg";
import Shape71 from "./res/images/shapes/71.svg";
import Shape72 from "./res/images/shapes/72.svg";
import Shape73 from "./res/images/shapes/73.svg";
import Shape74 from "./res/images/shapes/74.svg";
import Shape75 from "./res/images/shapes/75.svg";
import Shape76 from "./res/images/shapes/76.svg";
import Shape77 from "./res/images/shapes/77.svg";
import Shape78 from "./res/images/shapes/78.svg";
import Shape79 from "./res/images/shapes/79.svg";
import Shape80 from "./res/images/shapes/80.svg";
import Shape81 from "./res/images/shapes/81.svg";
import Shape82 from "./res/images/shapes/82.svg";
import Shape83 from "./res/images/shapes/83.svg";
import Shape84 from "./res/images/shapes/84.svg";
import Shape85 from "./res/images/shapes/85.svg";
import Shape86 from "./res/images/shapes/86.svg";
import Shape87 from "./res/images/shapes/87.svg";
import Shape88 from "./res/images/shapes/88.svg";
import {$KTM, KeyMetadatas} from "../../../../shared/types";

export enum Shape {
  SHAPE_01 = "shape-01",
  SHAPE_02 = "shape-02",
  SHAPE_03 = "shape-03",
  SHAPE_04 = "shape-04",
  SHAPE_05 = "shape-05",
  SHAPE_06 = "shape-06",
  SHAPE_07 = "shape-07",
  SHAPE_08 = "shape-08",
  SHAPE_09 = "shape-09",
  SHAPE_10 = "shape-10",
  SHAPE_11 = "shape-11",
  SHAPE_12 = "shape-12",
  SHAPE_13 = "shape-13",
  SHAPE_14 = "shape-14",
  SHAPE_15 = "shape-15",
  SHAPE_16 = "shape-16",
  SHAPE_17 = "shape-17",
  SHAPE_18 = "shape-18",
  SHAPE_19 = "shape-19",
  SHAPE_20 = "shape-20",
  SHAPE_21 = "shape-21",
  SHAPE_22 = "shape-22",
  SHAPE_23 = "shape-23",
  SHAPE_24 = "shape-24",
  SHAPE_25 = "shape-25",
  SHAPE_26 = "shape-26",
  SHAPE_27 = "shape-27",
  SHAPE_28 = "shape-28",
  SHAPE_29 = "shape-29",
  SHAPE_30 = "shape-30",
  SHAPE_31 = "shape-31",
  SHAPE_32 = "shape-32",
  SHAPE_33 = "shape-33",
  SHAPE_34 = "shape-34",
  SHAPE_35 = "shape-35",
  SHAPE_36 = "shape-36",
  SHAPE_37 = "shape-37",
  SHAPE_38 = "shape-38",
  SHAPE_39 = "shape-39",
  SHAPE_40 = "shape-40",
  SHAPE_41 = "shape-41",
  SHAPE_42 = "shape-42",
  SHAPE_43 = "shape-43",
  SHAPE_44 = "shape-44",
  SHAPE_45 = "shape-45",
  SHAPE_46 = "shape-46",
  SHAPE_47 = "shape-47",
  SHAPE_48 = "shape-48",
  SHAPE_49 = "shape-49",
  SHAPE_50 = "shape-50",
  SHAPE_51 = "shape-51",
  SHAPE_52 = "shape-52",
  SHAPE_53 = "shape-53",
  SHAPE_54 = "shape-54",
  SHAPE_55 = "shape-55",
  SHAPE_56 = "shape-56",
  SHAPE_57 = "shape-57",
  SHAPE_58 = "shape-58",
  SHAPE_59 = "shape-59",
  SHAPE_60 = "shape-60",
  SHAPE_61 = "shape-61",
  SHAPE_62 = "shape-62",
  SHAPE_63 = "shape-63",
  SHAPE_64 = "shape-64",
  SHAPE_65 = "shape-65",
  SHAPE_66 = "shape-66",
  SHAPE_67 = "shape-67",
  SHAPE_68 = "shape-68",
  SHAPE_69 = "shape-69",
  SHAPE_70 = "shape-70",
  SHAPE_71 = "shape-71",
  SHAPE_72 = "shape-72",
  SHAPE_73 = "shape-73",
  SHAPE_74 = "shape-74",
  SHAPE_75 = "shape-75",
  SHAPE_76 = "shape-76",
  SHAPE_77 = "shape-77",
  SHAPE_78 = "shape-78",
  SHAPE_79 = "shape-79",
  SHAPE_80 = "shape-80",
  SHAPE_81 = "shape-81",
  SHAPE_82 = "shape-82",
  SHAPE_83 = "shape-83",
  SHAPE_84 = "shape-84",
  SHAPE_85 = "shape-85",
  SHAPE_86 = "shape-86",
  SHAPE_87 = "shape-87",
  SHAPE_88 = "shape-88",
}

export type ShapeMetadata = {
  url: string,
}

export const SHAPES_METADATA = new KeyMetadatas<ShapeMetadata>([
  $KTM(Shape.SHAPE_01, {url: Shape01}),
  $KTM(Shape.SHAPE_02, {url: Shape02}),
  $KTM(Shape.SHAPE_03, {url: Shape03}),
  $KTM(Shape.SHAPE_04, {url: Shape04}),
  $KTM(Shape.SHAPE_05, {url: Shape05}),
  $KTM(Shape.SHAPE_06, {url: Shape06}),
  $KTM(Shape.SHAPE_07, {url: Shape07}),
  $KTM(Shape.SHAPE_08, {url: Shape08}),
  $KTM(Shape.SHAPE_09, {url: Shape09}),
  $KTM(Shape.SHAPE_10, {url: Shape10}),
  $KTM(Shape.SHAPE_11, {url: Shape11}),
  $KTM(Shape.SHAPE_12, {url: Shape12}),
  $KTM(Shape.SHAPE_13, {url: Shape13}),
  $KTM(Shape.SHAPE_14, {url: Shape14}),
  $KTM(Shape.SHAPE_15, {url: Shape15}),
  $KTM(Shape.SHAPE_16, {url: Shape16}),
  $KTM(Shape.SHAPE_17, {url: Shape17}),
  $KTM(Shape.SHAPE_18, {url: Shape18}),
  $KTM(Shape.SHAPE_19, {url: Shape19}),
  $KTM(Shape.SHAPE_20, {url: Shape20}),
  $KTM(Shape.SHAPE_21, {url: Shape21}),
  $KTM(Shape.SHAPE_22, {url: Shape22}),
  $KTM(Shape.SHAPE_23, {url: Shape23}),
  $KTM(Shape.SHAPE_24, {url: Shape24}),
  $KTM(Shape.SHAPE_25, {url: Shape25}),
  $KTM(Shape.SHAPE_26, {url: Shape26}),
  $KTM(Shape.SHAPE_27, {url: Shape27}),
  $KTM(Shape.SHAPE_28, {url: Shape28}),
  $KTM(Shape.SHAPE_29, {url: Shape29}),
  $KTM(Shape.SHAPE_30, {url: Shape30}),
  $KTM(Shape.SHAPE_31, {url: Shape31}),
  $KTM(Shape.SHAPE_32, {url: Shape32}),
  $KTM(Shape.SHAPE_33, {url: Shape33}),
  $KTM(Shape.SHAPE_34, {url: Shape34}),
  $KTM(Shape.SHAPE_35, {url: Shape35}),
  $KTM(Shape.SHAPE_36, {url: Shape36}),
  $KTM(Shape.SHAPE_37, {url: Shape37}),
  $KTM(Shape.SHAPE_38, {url: Shape38}),
  $KTM(Shape.SHAPE_39, {url: Shape39}),
  $KTM(Shape.SHAPE_40, {url: Shape40}),
  $KTM(Shape.SHAPE_41, {url: Shape41}),
  $KTM(Shape.SHAPE_42, {url: Shape42}),
  $KTM(Shape.SHAPE_43, {url: Shape43}),
  $KTM(Shape.SHAPE_44, {url: Shape44}),
  $KTM(Shape.SHAPE_45, {url: Shape45}),
  $KTM(Shape.SHAPE_46, {url: Shape46}),
  $KTM(Shape.SHAPE_47, {url: Shape47}),
  $KTM(Shape.SHAPE_48, {url: Shape48}),
  $KTM(Shape.SHAPE_49, {url: Shape49}),
  $KTM(Shape.SHAPE_50, {url: Shape50}),
  $KTM(Shape.SHAPE_51, {url: Shape51}),
  $KTM(Shape.SHAPE_52, {url: Shape52}),
  $KTM(Shape.SHAPE_53, {url: Shape53}),
  $KTM(Shape.SHAPE_54, {url: Shape54}),
  $KTM(Shape.SHAPE_55, {url: Shape55}),
  $KTM(Shape.SHAPE_56, {url: Shape56}),
  $KTM(Shape.SHAPE_57, {url: Shape57}),
  $KTM(Shape.SHAPE_58, {url: Shape58}),
  $KTM(Shape.SHAPE_59, {url: Shape59}),
  $KTM(Shape.SHAPE_60, {url: Shape60}),
  $KTM(Shape.SHAPE_61, {url: Shape61}),
  $KTM(Shape.SHAPE_62, {url: Shape62}),
  $KTM(Shape.SHAPE_63, {url: Shape63}),
  $KTM(Shape.SHAPE_64, {url: Shape64}),
  $KTM(Shape.SHAPE_65, {url: Shape65}),
  $KTM(Shape.SHAPE_66, {url: Shape66}),
  $KTM(Shape.SHAPE_67, {url: Shape67}),
  $KTM(Shape.SHAPE_68, {url: Shape68}),
  $KTM(Shape.SHAPE_69, {url: Shape69}),
  $KTM(Shape.SHAPE_70, {url: Shape70}),
  $KTM(Shape.SHAPE_71, {url: Shape71}),
  $KTM(Shape.SHAPE_72, {url: Shape72}),
  $KTM(Shape.SHAPE_73, {url: Shape73}),
  $KTM(Shape.SHAPE_74, {url: Shape74}),
  $KTM(Shape.SHAPE_75, {url: Shape75}),
  $KTM(Shape.SHAPE_76, {url: Shape76}),
  $KTM(Shape.SHAPE_77, {url: Shape77}),
  $KTM(Shape.SHAPE_78, {url: Shape78}),
  $KTM(Shape.SHAPE_79, {url: Shape79}),
  $KTM(Shape.SHAPE_80, {url: Shape80}),
  $KTM(Shape.SHAPE_81, {url: Shape81}),
  $KTM(Shape.SHAPE_82, {url: Shape82}),
  $KTM(Shape.SHAPE_83, {url: Shape83}),
  $KTM(Shape.SHAPE_84, {url: Shape84}),
  $KTM(Shape.SHAPE_85, {url: Shape85}),
  $KTM(Shape.SHAPE_86, {url: Shape86}),
  $KTM(Shape.SHAPE_87, {url: Shape87}),
  $KTM(Shape.SHAPE_88, {url: Shape88}),
]);
